const CLICK_PENDING_SAFTY_TASK_CARD = 'Click on Pending Safty Task Card';

const dashboardAnalyticsConstants = {
  CLICK_PENDING_SAFTY_TASK_CARD,
};
export default dashboardAnalyticsConstants;
